<template>
  <v-row justify="center">
    <v-card>
      <v-card-title>Create / Edit Restaurant</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 500px; width: 550px">
        <div class="row">
          <v-col cols="12" sm="4" class="label">
            <label>Restaurant name TH* :</label>
          </v-col>
          <v-col cols="12" sm="6">
            <input-text-field :model="form.name_th" @update="updateNameTH" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="4" class="label">
            <label>Restaurant name EN* :</label>
          </v-col>
          <v-col cols="12" sm="6" xs="12">
            <input-text-field :model="form.name_en" @update="updateNameEN" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="4" class="label">
            <label>Latitude* :</label>
          </v-col>
          <v-col cols="12" sm="6" xs="12">
            <input-text-field :model="form.lat" @update="updateLat" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="4" class="label">
            <label>Longitude* :</label>
          </v-col>
          <v-col cols="12" sm="6" xs="12">
            <input-text-field :model="form.lon" @update="updateLon" />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="4" class="label">
            <label>Address* :</label>
          </v-col>
          <v-col cols="12" sm="6" xs="12">
            <input-text-area :model="form.location" @update="updateLocation" />
          </v-col>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <div class="row text-right">
        <v-spacer></v-spacer>
        <cancel-button @click.native="cancelData" />
        <save-button @click.native="submitData" />
      </div>
    </v-card>
  </v-row>
</template>

<script>
import InputTextField from "../../../components/Input/InputTextField";
import InputTextArea from "../../../components/Input/InputTextArea";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import CancelButton from "../../../components/Button/CancelButton";
import Swal from "sweetalert";
export default {
  name: "CreateRestaurantModal",
  props: {
    form: Object
  },
  components: {CancelButton, SaveButton, PreviewButton, DeleteButton, InputTextArea, InputTextField },
  methods: {
    submitData() {
      if (!this.form.name_th) {
        Swal('','Please insert Restaurant name TH !','error');
        return false;
      } else if (!this.form.name_en) {
        Swal('','Please insert Restaurant name EN !','error');
        return false;
      } else if (!this.form.lat) {
        Swal('','Please insert latitude !','error');
        return false;
      } else if (!this.form.lon) {
        Swal('','Please insert longitude !','error');
        return false;
      } else if (!this.form.location) {
        Swal('','Please insert Address !','error');
        return false;
      } else {
        this.$emit("update", this.form);
      }
    },
    cancelData() {
      this.$emit("update", false);
    },
    updateNameTH(val) {
      this.form.name_th = val;
    },
    updateNameEN(val) {
      this.form.name_en = val;
    },
    updateLocation(val) {
      this.form.location = val;
    },
    updateLat(val) {
      this.form.lat = val;
    },
    updateLon(val) {
      this.form.lon = val;
    }
  }
};
</script>

<style scoped></style>
